import "core-js/modules/web.dom-collections.iterator.js";
import ReferenceMixin from "../../../lib/ModelMixins/ReferenceMixin";
import CatalogMemberFactory from "../../../lib/Models/Catalog/CatalogMemberFactory";
import registerCatalogMembers from "../../../lib/Models/Catalog/registerCatalogMembers";
import hasTraits from "../../../lib/Models/Definition/hasTraits";
import Terria from "../../../lib/Models/Terria";
import LegendOwnerTraits from "../../../lib/Traits/TraitsClasses/LegendOwnerTraits";
describe("All Catalog models", () => {
  // AKA developer shock collar - stop developers from doing undesirable things

  let models;
  beforeEach(() => {
    const terria = new Terria({
      baseUrl: "./"
    });
    registerCatalogMembers();
    models = CatalogMemberFactory.constructorsArray.map(_ref => {
      let [modelName, modelConstructor] = _ref;
      return [modelName, new modelConstructor(undefined, terria, undefined, undefined)];
    });
  });
  it("Have LegendOwnerTraits, unless they use ReferenceMixin, or are explicitly excluded", () => {
    // Intended to prevent newly created CatalogItems from accidentally forgetting to include LegendOwnerTraits
    models.filter(_ref2 => {
      let [modelName, model] = _ref2;
      return !ReferenceMixin.isMixedInto(model) && !["stub", "group", "cesium-terrain", "default-timeline"].includes(modelName);
    }).forEach(_ref3 => {
      let [modelName, model] = _ref3;
      return expect(hasTraits(model, LegendOwnerTraits, "legends")).toBeTruthy("`legends` missing for ".concat(modelName));
    });
  });
  it("Don't have a `legends` or `legend` property unless they have LegendOwnerTraits", () => {
    // The only correct way to provide a legend is through legendOwnerTraits.
    models.filter(_ref4 => {
      let [_modelName, model] = _ref4;
      return !hasTraits(model, LegendOwnerTraits, "legends");
    }).forEach(_ref5 => {
      let [modelName, model] = _ref5;
      expect(model.legends).toBeUndefined("`legends` present for ".concat(modelName));
      expect(model.legend).toBeUndefined("`legend` present for ".concat(modelName));
    });
  });
});